/**
 * Detect the `impersonationError` query flag from an SSR-safe search string.
 *
 * @example
 * const hasImpersonationError = getHasImpersonationError(location.search);
 */
export function getHasImpersonationError(search: string): boolean {
  return new URLSearchParams(search).has("impersonationError");
}
